import React from 'react';

import { SlideOverTopContentProps } from './types';

const SlideOverTopContent: React.FC<SlideOverTopContentProps> = ({
  children,
  ...props
}) => {
  return (
    <div {...props}>
      {children}
    </div>
  );
};

export { SlideOverTopContent };
